import { graphql } from "react-relay"

const chAuditQuery = graphql`
  query chAuditQuery($patientId: ID!, $fromDate: Date, $toDate: Date) {
    auditEvents: ch_auditEvents(first: 1000, patientId: $patientId, fromDate: $fromDate, toDate: $toDate) {
      edges {
        node {
          action
          eventTime
          userName
          jsonPayload
        }
      }
    }
  }
`

export { chAuditQuery }
